export default __webpack_public_path__ + "static/media/image-not-found.a33b48dd.jpg";